import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoUsersGroup = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>UsersGroup</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.84 10.724a4.032 4.032 0 1 1 8.063 0 4.032 4.032 0 0 1-8.064 0Zm4.031-6.032a6.032 6.032 0 0 0-3.386 11.025 10.146 10.146 0 0 0-4.736 3.502 1.727 1.727 0 0 0 .17 2.255c2.056 2.05 4.86 3.32 7.953 3.32 3.094 0 5.898-1.27 7.955-3.321a1.727 1.727 0 0 0 .168-2.255 10.146 10.146 0 0 0-4.736-3.502A6.032 6.032 0 0 0 21.87 4.692Zm.001 18.1c-2.45 0-4.685-.968-6.372-2.57a8.104 8.104 0 0 1 6.373-3.086 8.104 8.104 0 0 1 6.372 3.086c-1.687 1.602-3.923 2.57-6.373 2.57Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.714 11.306c0-5.524 4.478-10.001 10.001-10.001 5.524 0 10.001 4.477 10.001 10 0 2.57-.968 4.911-2.559 6.682a15.875 15.875 0 0 1 5.242 4.516 3.889 3.889 0 0 1-.377 5.078c-3.173 3.163-7.512 5.133-12.308 5.133-4.795 0-9.133-1.969-12.306-5.131a3.889 3.889 0 0 1-.377-5.079 15.874 15.874 0 0 1 5.242-4.516 9.964 9.964 0 0 1-2.56-6.682Z"
      fill="#F6F7F8"
    />
    <path
      d="M3.426 25.558a1.031 1.031 0 0 1-.103-1.348 12.927 12.927 0 0 1 10.392-5.224c4.255 0 8.031 2.053 10.39 5.223.308.412.263.985-.102 1.348-2.67 2.662-6.296 4.299-10.29 4.299-3.992 0-7.618-1.636-10.287-4.298Z"
      stroke="currentColor"
      strokeWidth={2}
    />
    <circle cx={13.714} cy={11.306} r={7.143} stroke="currentColor" strokeWidth={2} />
  </svg>
);
export default SvgIcoUsersGroup;
